import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

const RevealingText = ({
  text = "",
  textOpacity = null,
  textSize = "text-4xl",
  infinite = null,
}) => {
  const { ref, inView } = useInView({ threshold: 0.5 });
  const [textState, setTextState] = useState({ y: "100%", opacity: 0 });
  useEffect(() => {
    if (infinite) {
      if (inView) {
        setTextState({ y: 0, opacity: 1 });
      } else {
        setTextState({ y: "100%", opacity: 0 });
      }
    } else if (inView && !textState.opacity) {
      setTextState({ y: 0, opacity: 1 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <p
      ref={ref}
      className={`${textSize} w-full flex flex-wrap mb-8 text-dark dark:text-light ${
        textOpacity ? textOpacity : ``
      }`}
    >
      {text.split(" ").map((word, index, array) => {
        return (
          <motion.span
            initial={{ y: "100%", opacity: 0 }}
            animate={textState}
            transition={{ duration: 0.75, delay: 0.025 * index }}
          >
            {word}&nbsp;
          </motion.span>
        );
      })}
    </p>
  );
};

export default RevealingText;
